"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaddingAll;
(function (PaddingAll) {
    PaddingAll["One"] = "ty-pd-1";
    PaddingAll["Two"] = "ty-pd-2";
    PaddingAll["Three"] = "ty-pd-3";
    PaddingAll["Four"] = "ty-pd-4";
    PaddingAll["Five"] = "ty-pd-5";
    PaddingAll["Six"] = "ty-pd-6";
    PaddingAll["Seven"] = "ty-pd-7";
    PaddingAll["Auto"] = "ty-pd-auto";
    PaddingAll["Zero"] = "ty-pd-zero";
})(PaddingAll = exports.PaddingAll || (exports.PaddingAll = {}));
var PaddingLeft;
(function (PaddingLeft) {
    PaddingLeft["One"] = "ty-pdl-1";
    PaddingLeft["Two"] = "ty-pdl-2";
    PaddingLeft["Three"] = "ty-pdl-3";
    PaddingLeft["Four"] = "ty-pdl-4";
    PaddingLeft["Five"] = "ty-pdl-5";
    PaddingLeft["Six"] = "ty-pdl-6";
    PaddingLeft["Seven"] = "ty-pdl-7";
    PaddingLeft["Auto"] = "ty-pdl-auto";
    PaddingLeft["Zero"] = "ty-pdl-zero";
})(PaddingLeft = exports.PaddingLeft || (exports.PaddingLeft = {}));
var PaddingTop;
(function (PaddingTop) {
    PaddingTop["One"] = "ty-pdt-1";
    PaddingTop["Two"] = "ty-pdt-2";
    PaddingTop["Three"] = "ty-pdt-3";
    PaddingTop["Four"] = "ty-pdt-4";
    PaddingTop["Five"] = "ty-pdt-5";
    PaddingTop["Six"] = "ty-pdt-6";
    PaddingTop["Seven"] = "ty-pdt-7";
    PaddingTop["Auto"] = "ty-pdt-auto";
    PaddingTop["Zero"] = "ty-pdt-zero";
})(PaddingTop = exports.PaddingTop || (exports.PaddingTop = {}));
var PaddingRight;
(function (PaddingRight) {
    PaddingRight["One"] = "ty-pdr-1";
    PaddingRight["Two"] = "ty-pdr-2";
    PaddingRight["Three"] = "ty-pdr-3";
    PaddingRight["Four"] = "ty-pdr-4";
    PaddingRight["Five"] = "ty-pdr-5";
    PaddingRight["Six"] = "ty-pdr-6";
    PaddingRight["Seven"] = "ty-pdr-7";
    PaddingRight["Auto"] = "ty-pdr-auto";
    PaddingRight["Zero"] = "ty-pdr-zero";
})(PaddingRight = exports.PaddingRight || (exports.PaddingRight = {}));
var PaddingBottom;
(function (PaddingBottom) {
    PaddingBottom["One"] = "ty-pdb-1";
    PaddingBottom["Two"] = "ty-pdb-2";
    PaddingBottom["Three"] = "ty-pdb-3";
    PaddingBottom["Four"] = "ty-pdb-4";
    PaddingBottom["Five"] = "ty-pdb-5";
    PaddingBottom["Six"] = "ty-pdb-6";
    PaddingBottom["Seven"] = "ty-pdb-7";
    PaddingBottom["Auto"] = "ty-pdb-auto";
    PaddingBottom["Zero"] = "ty-pd-zero";
})(PaddingBottom = exports.PaddingBottom || (exports.PaddingBottom = {}));
